import { render, staticRenderFns } from "./UsersDeletedRow.vue?vue&type=template&id=79799c80"
import script from "./UsersDeletedRow.vue?vue&type=script&lang=js"
export * from "./UsersDeletedRow.vue?vue&type=script&lang=js"
import style0 from "./UsersDeletedRow.vue?vue&type=style&index=0&id=79799c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports